module.exports = __webpack_public_path__ + "img/vote_low.1f496232.svg";